module.exports = __webpack_public_path__ + "static/img/ajxc.a2efad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/ajxc.png
// module id = saVS
// module chunks = 0